import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://json-server-by-tahmid.herokuapp.com",
});

export default axiosInstance;
